export default __webpack_public_path__ + "static/media/delete_icon.6d2846ac.svg";